"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/utils/toAddress.ts
var _ton = require('@ton/ton');
function toAddress(addressValue) {
  if (addressValue instanceof _ton.Address) {
    return addressValue;
  }
  return _ton.address.call(void 0, addressValue.toString());
}



exports.toAddress = toAddress;
//# sourceMappingURL=chunk-QBYZPWDO.cjs.map